import { useState, useEffect, useCallback, useMemo } from "react";
import { Select, SelectProps } from "antd";
import { searchUsersGlobal } from '../../api/user';
import { debounce, uniqWith } from 'lodash';

const searchCache = new Map();

export default function UserLookup({
    value, initOptions = [], onChange, ...selectProps
}: SelectProps & {
    initOptions?: SelectProps['options']
}) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<UserRecord[]>([]);
    const [keywords, setKeywords] = useState<string>();
    const fetchData = useCallback(debounce(({ keywords }) => {
        const cache = searchCache.get(keywords);
        if(cache) return setData(cache);
        setLoading(true)
        searchUsersGlobal({
            queryName: keywords,
            pageNum: 1, pageSize: 20
        })
            ?.then((data) => {
                setData(data.data)
                if (searchCache.size < 100) {
                    searchCache.set(keywords, JSON.parse(JSON.stringify(data.data)))
                }
            })
            .finally(() => setLoading(false))

    }, 500), [setData, setLoading]);
    useEffect(() => {
        fetchData({ keywords })
    }, [fetchData, keywords]);
    const options = useMemo(() => {
        const isSelected  = (item: {value?: any}) => Array.isArray(value) ? value.some(i => i === item.value) :  item.value === value;
        const _initOptions = (initOptions || []).filter(i => isSelected(i));
        const arr = uniqWith(
            [
                ...data?.map(i => (
                    {
                        value: i.userId,
                        label: i.name
                    }
                )),
                ..._initOptions
            ], (a, b) => a.value === b.value);
        return arr.sort((a, b) => { 
            // 已选的靠后展示
            if (isSelected(a) && !isSelected(b)) {
                return 1
            }
            if (!isSelected(a) && isSelected(b)) {
                return -1
            }
            return 0;
        });
    },
        [initOptions, data, value])

    return <Select
        placeholder='请输入姓名'
        {...selectProps}
        loading={loading}
        options={options}
        style={{
            ...selectProps.style,
        }}
        defaultActiveFirstOption={false}
        filterOption={false}
        value={value}
        searchValue={keywords}
        allowClear
        onSearch={keywords => {
            setKeywords(keywords)
        }}
        onChange={(...args) => {
            onChange?.(...args);
            setKeywords('')
        }}
        showSearch
    />
}